export const configDefaults = {
    productUrlFormatter: (product) => {
        return product.url || '';
    },
};
export const createAnalyticsConfig = (config) => {
    return {
        ...configDefaults,
        ...config,
    };
};
